import React from 'react';
import { WeaFormItem, WeaSelect, WeaInput, WeaLocaleProvider } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

class ETabWidth extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            tabwidth: this.props.tabwidth || '76',
            methodvalue: this.props.methodvalue || '2'
        }
    }

    getSaveValues() {
        const { tabwidth, methodvalue } = this.state;
        let data = {};
        if(methodvalue == '2'){
            data = {
                tabwidth: '76',
                methodvalue: '2'
            };
        }else data = {tabwidth,methodvalue };
        return data;
    }

    render(){
        const { tabwidth, methodvalue } = this.state;
        const { disabled } = this.props;
        const options = [
            {
                key: "1",
                showname: getLabel(501539,'固定宽度')
            },
            {
                key: "2",
                selected: true,
                showname: getLabel(128975,'自适应') ,
            }
        ];
        return (
            <WeaFormItem label={getLabel(501540,'tab页宽度') } labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <div style={{width : '90px', display: 'inline-block', float: 'left'}}>
                    <WeaSelect
                        options={options}
                        value={methodvalue}
                        onChange={v => {
                            this.setState({methodvalue : v});
                        }}
                        disabled={disabled}
                    />
                </div>
                {
                    methodvalue == '1' &&
                    <div style={{display: 'inline-block'}}>
                        <WeaInput
                            value={tabwidth}
                            disabled={disabled}
                            style={{width: '54px', marginLeft: '15px'}}
                            onChange={v=> {this.setState({tabwidth : v})}}/>
                        <div style={{display: 'inline-block', marginBottom: '6px', marginLeft: '15px'}}>px</div>
                    </div>
                }
            </WeaFormItem>
        )
    }
}


export default ETabWidth;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/base/ETabWidth.js